import React, { Component } from "react";

import { collection, query, where, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import db from "../../../../firebase.config";

import Header from "../../../general/Headers/Header";
import Heading from "../../../general/heading/heading.component";
import Button from "../../../general/button/button.component";
import { studentUSN } from "../../general/sign-in/sign-in.component";
import Chip from "@mui/material/Chip";
import { Grid } from "@mui/material";
import OutlinedCard from "../../../general/card/card.component";
import { Divider } from "@mui/material";
import Upload from "./upload/upload.component";
import SimpleAccordion from "./accordion/accordion.component";
import "./dashboard.css";

import { isLoggedIn } from "../../general/sign-in/sign-in.component";
const finalList = [];

const data = async (USN) => {
  const allStudentsRef = collection(db, "studentData");
  const queryUSN = query(allStudentsRef, where("USN", "==", USN));
  const docsSnapshot = await getDocs(queryUSN);

  docsSnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    finalList.push(doc.data());
  });

  return finalList[0];
};

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      fullname: "",
    };
  }
  componentDidMount() {
    data(studentUSN).then((response) => this.setState(response));
  }

  render() {
    if (!isLoggedIn) {
      window.location.replace("../../../notfound");
    }
    return (
      <div style={{ marginBottom: "2rem" }}>
        <Grid container justifyContent="center" display="flex">
          <Grid container justifyContent="center">
            <Grid item justifyContent="center" lg={12} md={12}>
              <Header />
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid item justifyContent="center" lg={12} md={12}>
              <br /> <br /> <br />
              <Heading text="Dashboard" />
            </Grid>
          </Grid>
          <Grid container justifyContent="center" sx={{ mt: 5 }}>
            <Grid item>
              <OutlinedCard
                sx={{
                  textAlign: "center",
                  fontSize: "h2.fontSize",
                  fontFamily: "Montserrat",
                  mr: 10,
                  width : 600
                }}
                content={this.state.fullname.split(" ")[0]}
              />
            </Grid>
            <Grid item>
              <OutlinedCard
                sx={{
                  textAlign: "center",
                  fontSize: "h2.fontSize",
                  fontFamily: "Montserrat",
                  ml: 10,
                  width : 600
                }}
                content={this.state.USN}
              />
            </Grid>
          <Grid item sx={{ mt: 5 }}>
            <h3>{ this.state.companies ? (this.state.companies.length? `You've reached your companies limit!` : null) : null }</h3>
          </Grid>
          </Grid>
        </Grid>
        <Divider sx={{ mt: 10 }}></Divider>
        <Grid container justifyContent="center" sx={{ mt: 5 }}>
          <Grid item>
            <SimpleAccordion name={this.state} />
          </Grid>
        </Grid>
        <Grid container justifyContent="center" sx={{ mt: 5 }}>
          <Grid item>
            {this.state.hasUploadedResume === true
              ? "You have uploaded your resume"
              : null}
          </Grid>
        </Grid>
        <Grid container justifyContent="center" sx={{ mt: 1 }}>
          <Grid item>
            <Upload hasUploadedUSN={this.state.USN} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default Dashboard;
